'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import type { CartPayment } from '@eliadmin/core/src/api/cart/cart-types';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { RadioGroupItem } from '@eliadmin/core/src/components/ui/radio-group';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';

type JobportalPaymentCardProps = {
  payment: CartPayment;
};

export function JobportalPaymentCard({ payment }: JobportalPaymentCardProps) {
  const { t } = useTranslations();
  const currency = useGlobalStore(state => state.generalLayout.currency);

  return (
    <Label
      htmlFor={`payment-${payment.id}`}
      className={cn(
        'flex cursor-pointer items-center justify-between rounded-lg border p-4',
        'Jobportal-payment-card',
      )}
    >
      <div className="flex items-center gap-4">
        <RadioGroupItem
          id={`payment-${payment.id}`}
          value={String(payment.id)}
          className="Jobportal-payment-radio"
        />
        {payment.image && (
          <Image
            alt={resolveImageAlt(payment?.image, payment?.name)}
            src={payment.image.url}
            width={40}
            height={40}
            className="Jobportal-payment-image"
          />
        )}
        <div>
          <p className="text-sm font-bold">{payment.name}</p>
          <HtmlRenderer
            html={payment.description}
            className="h-4 text-xs font-normal text-muted-foreground [&_p]:text-[10px] [&_p]:leading-4"
          />
        </div>
      </div>
      <span className="text-sm font-bold">
        {/* {payment.price_with_vat ? formatPrice(payment.price_with_vat, currency) : t('text349')} */}
        {payment.price_with_vat ? `${formatPrice(payment.price_with_vat, currency)} bez DPH` : ''}
      </span>
    </Label>
  );
}
